import { useEffect } from "react";

// Custom hook to handle clicks outside of a component
const useOutsideClick = (ref, callback = () => {}, btnRef, isOpen) => {
  useEffect(() => {
    if (isOpen) {
      // Function to handle the click event
      function handleClickOutside(event) {
        // If the click was outside the ref element and not on the btnRef element
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          btnRef?.current !== event.target
        ) {
          callback(); // Call the callback function
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Remove the event listener for 'mousedown' events 
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [ref, btnRef, callback, isOpen]); // Dependencies of the effect
};

export default useOutsideClick;